import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { Trans } from 'react-i18next'
import moment from 'moment'
import i18n from '../../../i18n'
import { LbToast } from '../../common/SimpleComponents/LBToasts'
import { LbLoader } from '../../common/SimpleComponents/LBLoader'
import LbModal from '../../common/Modal/LbModal'
import LBCircularCountDown from '../../common/SimpleComponents/LBCircularCountDown'
import CurrentTaskDetails from '../Transactions/CurrentTasks/CurrentTaskDetails'
import LbErrorMessage from '../../common/SimpleComponents/LbErrorMessage'
import Icon from '../../common/SimpleComponents/Icon'
import transfer from '../../api/transfer.api'
import {
  fetchCurrentTaskDetailsAjax,
  fetchSpecialRatePendingTasksAjax
} from '../../api/corporate/currentTask.api'
import {
  buildFxHubConnection,
  closeFxHubConnection,
  getFxConnectionInstance
} from '../../helpers/fxSignalrConnection'
import {
  subscribeFxStatusUpdates,
  unsubscribeFxStatusUpdates
} from '../../helpers/fxStatusService'
import { getActiveSpecRateTaskId } from '../../helpers/fxModalTracker'

import '../../../assets/scss/component/transactions.scss'

class RetailSpecRateGlobal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      notifications: [],
      currentTasks: [],
      currentTaskIndex: null,
      modalOpenTaskId: null,
      taskDetail: null,
      taskDetailLoading: false,
      taskDetailError: null,
      submitting: false,
      showCancelationRow: false,
      reason: '',
      totalMillis: 0
    }
    this.handleFxStatusUpdate = this.handleFxStatusUpdate.bind(this)
    this.showNotification = this.showNotification.bind(this)
    this.hideNotification = this.hideNotification.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  componentDidMount() {
    const connection = buildFxHubConnection()
    if (connection) {
      subscribeFxStatusUpdates(connection, this.handleFxStatusUpdate)
    }

    this.fetchPendingApprovals()

    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        const conn = getFxConnectionInstance()
        if (!conn) {
          const newConn = buildFxHubConnection()
          if (newConn) {
            subscribeFxStatusUpdates(newConn, this.handleFxStatusUpdate)
          }
        }
      }
    }
    document.addEventListener('visibilitychange', this.visibilityHandler)
  }

  fetchPendingApprovals() {
    fetchSpecialRatePendingTasksAjax()
      .then(data => {
        if (!data || data.length === 0) return
        data
          .filter(task => task.status === 'IsTemporary')
          .forEach(task => {
            if (!this.state.notifications.includes(task.paymentId)) {
              this.showNotification({
                id: task.paymentId,
                consentExpirationTime: task.consentExpirationTime
              })
            }
          })
      })
      .catch(() => {})
  }

  componentDidUpdate(prevProps, prevState) {
    const detail = this.state.taskDetail
    if (!detail || detail.exchangetype !== 'SpecialRate') return

    let timer =
      detail.status === 'IsTemporary' ? detail.consentExpirationTime : null

    if (timer && detail !== prevState.taskDetail) {
      clearInterval(this.countdownTimer)
      if (
        moment
          .unix(timer)
          .subtract(4, 'hours')
          .isAfter(moment())
      ) {
        this.setState({
          totalMillis: moment
            .unix(timer)
            .subtract(4, 'hours')
            .diff(moment())
        })

        this.countdownTimer = setInterval(() => {
          this.forceUpdate()
          if (
            moment
              .unix(timer)
              .subtract(4, 'hours')
              .isBefore(moment())
          ) {
            clearInterval(this.countdownTimer)
            this.detailsModal.handleCloseModal()
            this.onTaskSuccess(detail.id)
          }
        }, 1000)
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.countdownTimer)
    const connection = getFxConnectionInstance()
    if (connection) {
      unsubscribeFxStatusUpdates(connection)
    }
    closeFxHubConnection()
    document.removeEventListener('visibilitychange', this.visibilityHandler)
  }

  handleFxStatusUpdate(paymentId) {
    if (this.state.notifications.includes(paymentId)) return

    fetchCurrentTaskDetailsAjax(paymentId).then(
      task => {
        if (!task) return

        if (task.status === 'IsTemporary') {
          this.showNotification(task)
        } else if (task.status === 'Rejected') {
          LbToast('error', i18n.t('CurrentTasks.TaskCancelFailed'))
          this.addNotification(paymentId)
          this.openModal(paymentId)
        }
      },
      () => {
        LbToast('error', i18n.t('Common.Error'))
      }
    )
  }

  addNotification(paymentId) {
    this.setState(prev => ({
      notifications: [...prev.notifications, paymentId]
    }))
  }

  showNotification(task) {
    let notifications = [...this.state.notifications]
    let currentTasks = [...this.state.currentTasks]

    if (!notifications.includes(task.id)) {
      notifications.push(task.id)
      currentTasks.unshift({
        id: task.id,
        expiration: task.consentExpirationTime
      })

      this.setState({ notifications, currentTasks }, () => {
        let expiration = moment(
          moment
            .unix(task.consentExpirationTime)
            .subtract(4, 'hours')
            .diff(moment())
        ).format('x')

        LbToast('warning', i18n.t('CurrentTasks.AwaitingYourApproval'), {
          onOpen: () => {
            setTimeout(() => this.autoOpenModal(task.id), 10000)
          },
          autoClose: parseInt(expiration),
          toastId: task.id,
          onClick: () => this.openModal(task.id)
        })
      })
    }
  }

  hideNotification = taskId => {
    let notifications = [...this.state.notifications]
    let currentTasks = [...this.state.currentTasks]

    if (notifications.includes(taskId)) {
      this.setState(
        {
          notifications: notifications.filter(n => n !== taskId),
          currentTasks: currentTasks.filter(t => t.id !== taskId)
        },
        () => {
          toast.dismiss(taskId)
        }
      )
    }
  }

  onTaskSuccess = taskId => {
    this.hideNotification(taskId)
  }

  autoOpenModal = taskId => {
    if (!this.state.modalOpenTaskId && getActiveSpecRateTaskId() !== taskId) {
      this.openModal(taskId)
    }
  }

  openModal(taskId) {
    if (this.state.modalOpenTaskId === taskId) return

    const currentTaskIndex = this.state.currentTasks.findIndex(
      t => t.id === taskId
    )

    this.setState({
      taskDetail: null,
      taskDetailLoading: true,
      taskDetailError: null,
      showCancelationRow: false,
      reason: '',
      modalOpenTaskId: taskId,
      currentTaskIndex: currentTaskIndex >= 0 ? currentTaskIndex : null
    })

    if (!this.detailsModal.isOpened()) {
      this.detailsModal.handleOpenModal()
    }

    fetchCurrentTaskDetailsAjax(taskId).then(
      result => {
        this.setState({
          taskDetail: result,
          taskDetailLoading: false,
          taskDetailError: null
        })
      },
      error => {
        this.setState({
          taskDetailLoading: false,
          taskDetailError: error
        })
      }
    )
  }

  navigateTask(direction) {
    const { currentTasks, currentTaskIndex } = this.state
    if (currentTasks.length === 0) return

    let newIndex
    if (currentTaskIndex === null) {
      newIndex = direction > 0 ? 0 : currentTasks.length - 1
    } else {
      newIndex = currentTaskIndex + direction
    }
    if (newIndex < 0 || newIndex >= currentTasks.length) return

    const taskId = currentTasks[newIndex].id
    clearInterval(this.countdownTimer)

    this.setState({
      taskDetail: null,
      taskDetailLoading: true,
      taskDetailError: null,
      showCancelationRow: false,
      reason: '',
      modalOpenTaskId: taskId,
      currentTaskIndex: newIndex
    })

    fetchCurrentTaskDetailsAjax(taskId).then(
      result => {
        this.setState({
          taskDetail: result,
          taskDetailLoading: false,
          taskDetailError: null
        })
      },
      error => {
        this.setState({
          taskDetailLoading: false,
          taskDetailError: error
        })
      }
    )
  }

  prevTask = () => this.navigateTask(-1)
  nextTask = () => this.navigateTask(1)

  modalCloseCallback = () => {
    clearInterval(this.countdownTimer)
    this.setState({
      taskDetail: null,
      taskDetailLoading: false,
      taskDetailError: null,
      showCancelationRow: false,
      reason: '',
      submitting: false,
      modalOpenTaskId: null,
      currentTaskIndex: null
    })
  }

  handleConfirm = () => {
    this.setState({ submitting: true })
    const detail = this.state.taskDetail

    transfer
      .confirmTransferToAccount(detail.id, detail.description)
      .then(() => {
        LbToast('success', i18n.t('CurrentTasks.TaskConfirmSuccess'))
        this.onTaskSuccess(detail.id)
        this.refetchCurrentTask(detail.id)
      })
      .catch(err => {
        LbToast(
          'error',
          (err.errors && err.errors[0]) ||
            i18n.t('CurrentTasks.TaskConfirmFailed')
        )
      })
      .finally(() => this.setState({ submitting: false }))
  }

  handleCancel = () => {
    this.setState({ submitting: true })
    this.warningModal.handleCloseModal()
    const detail = this.state.taskDetail

    transfer
      .cancelTransferToAccount(detail.id, this.state.reason)
      .then(() => {
        LbToast('success', i18n.t('CurrentTasks.TaskCancelSuccess'))
        this.onTaskSuccess(detail.id)
        this.refetchCurrentTask(detail.id)
      })
      .catch(() => {
        LbToast('error', i18n.t('CurrentTasks.TaskCancelFailed'))
      })
      .finally(() => this.setState({ submitting: false }))
  }

  refetchCurrentTask = taskId => {
    clearInterval(this.countdownTimer)
    this.setState({
      taskDetailLoading: true,
      showCancelationRow: false,
      reason: '',
      currentTasks: this.state.currentTasks.filter(t => t.id !== taskId),
      currentTaskIndex: null
    })

    fetchCurrentTaskDetailsAjax(taskId).then(
      result => {
        this.setState({
          taskDetail: result,
          taskDetailLoading: false,
          taskDetailError: null
        })
      },
      error => {
        this.setState({
          taskDetailLoading: false,
          taskDetailError: error
        })
      }
    )
  }

  cancelTask = () => {
    this.setState({ showCancelationRow: true })
  }

  render() {
    const data = this.state.taskDetail
    const isSpecialRate = data && data.exchangetype === 'SpecialRate'
    const { currentTasks, currentTaskIndex } = this.state
    const isProcessed = currentTaskIndex === null && currentTasks.length > 0
    const hasPrev = isProcessed
      ? false
      : currentTaskIndex !== null && currentTaskIndex > 0
    const hasNext = isProcessed
      ? true
      : currentTaskIndex !== null && currentTaskIndex < currentTasks.length - 1

    let timer =
      (data || {}).status === 'IsTemporary'
        ? data.consentExpirationTime
        : null

    return (
      <div>
        <LbModal
          ref={modal => {
            this.warningModal = modal
          }}
          header={i18n.t('Common.Warning')}
          className="mw-500"
          style={{ overlay: { zIndex: 14 } }}
        >
          <div className="lb-confirm-text fnt-15">
            <Trans i18nKey="CurrentTasks.ConfirmCancel" />
          </div>
          <div className="lb-popup-footer">
            <button
              className="lb-btn btn-border btn-white"
              onClick={() =>
                this.setState({ showCancelationRow: false }, () =>
                  this.warningModal.handleCloseModal()
                )
              }
            >
              <Trans i18nKey="Common.No" />
            </button>
            <button
              className="lb-btn btn-red"
              onClick={this.handleCancel}
              disabled={this.state.submitting}
            >
              <Trans i18nKey="Common.Yes" />
            </button>
          </div>
          {this.state.submitting && (
            <LbLoader isLoading inCenter size="small" />
          )}
        </LbModal>

        <LbModal
          ref={modal => {
            this.detailsModal = modal
          }}
          header={i18n.t('Common.Details')}
          className="mw-750 lb-popup-slider current-tasks-slider"
          shouldCloseOnOverlayClick={false}
          modalCloseCallback={this.modalCloseCallback}
          style={{ overlay: { zIndex: 13 } }}
        >
          <div className="po-r slider-block">
            {hasPrev && (
              <i
                className="icn lb-slider-prev"
                onClick={this.prevTask}
              >
                <Icon name="icn-arrow-down" view="0 0 10.112 6" />
              </i>
            )}

            {hasNext && (
              <i
                className="icn lb-slider-next"
                onClick={this.nextTask}
              >
                <Icon name="icn-arrow-down" view="0 0 10.112 6" />
              </i>
            )}

            {!this.state.taskDetailError &&
              data &&
              !this.state.taskDetailLoading && (
                <Fragment>
                  <CurrentTaskDetails currentTask={data} />

                  {isSpecialRate &&
                    timer &&
                    moment
                      .unix(timer)
                      .subtract(4, 'hours')
                      .isAfter(moment()) && (
                      <div className="flex-aligned progrees-c">
                        <LBCircularCountDown
                          strokeWidth="1"
                          sqSize="10"
                          percentage={Math.trunc(
                            ((this.state.totalMillis -
                              moment
                                .unix(timer)
                                .subtract(4, 'hours')
                                .diff(moment())) /
                              this.state.totalMillis) *
                              100
                          )}
                        />
                        <div className="is-red fnt-low fnt-25 ml-15 w-10">
                          {moment(
                            moment
                              .unix(timer)
                              .subtract(4, 'hours')
                              .diff(moment())
                          ).format('mm:ss')}
                        </div>
                        <div className="fnt-low fnt-13 ml-40 flex-1">
                          <Trans i18nKey="CurrentTasks.ApprovalTimerText" />
                        </div>
                      </div>
                    )}

                  <div className="lb-popup-footer flex-justify-end">
                    {data.status === 'IsTemporary' &&
                    !this.state.showCancelationRow ? (
                      <Fragment>
                        <div className="lb-trans-info mb-5 flex-aligned" />
                        <div className="fnt-14 fnt-upper-m">
                          <div className="flex-aligned">
                            <button
                              className="lb-btn btn-red"
                              onClick={this.cancelTask}
                              disabled={this.state.submitting}
                            >
                              <Trans i18nKey="CurrentTasks.Cancel" />
                            </button>
                            <button
                              className="lb-btn btn-red"
                              onClick={this.handleConfirm}
                              disabled={this.state.submitting}
                            >
                              <Trans i18nKey="CurrentTasks.Confirmation" />
                            </button>
                          </div>
                        </div>
                      </Fragment>
                    ) : this.state.showCancelationRow ? (
                      <Fragment>
                        <div className="fnt-14 fnt-low-m details-canceled-reason">
                          <span>
                            <Trans i18nKey="CurrentTasks.CancelationReason" />
                          </span>
                          <input
                            type="text"
                            className="lb-input lb-input-grey mt-5"
                            placeholder={i18n.t(
                              'CurrentTasks.CancelationReason'
                            )}
                            value={this.state.reason}
                            maxLength={100}
                            onChange={e =>
                              this.setState({ reason: e.target.value })
                            }
                          />
                        </div>
                        <button
                          className="lb-btn btn-red mt-15"
                          onClick={() => this.warningModal.handleOpenModal()}
                          disabled={this.state.submitting}
                        >
                          <Trans i18nKey="CurrentTasks.Cancel" />
                        </button>
                      </Fragment>
                    ) : null}
                  </div>
                </Fragment>
              )}

            <LbLoader
              isLoading={this.state.taskDetailLoading}
              inCenter
              size="small"
            />
            {this.state.taskDetailError && (
              <LbErrorMessage message="error" type="modal" />
            )}
          </div>
          {this.state.submitting && (
            <LbLoader isLoading inCenter size="small" />
          )}
        </LbModal>
      </div>
    )
  }
}

export default connect(state => {
  const { oidc } = state
  return {
    token: oidc.user.access_token
  }
})(RetailSpecRateGlobal)
